(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/tipsen/engine/assets/javascripts/services.js') >= 0) return;  svs.modules.push('/components/tipsen/engine/assets/javascripts/services.js'); "use strict";

var _svs$core$config$data, _svs$core$config$data2;
const {
  resolveProductId,
  productIds
} = svs.utils.products;
const {
  pay
} = svs.lbUtils.wager;
const {
  jupiter,
  log
} = svs.core;
const {
  convert1X2ToSigns
} = svs.components.sport.tipsenShared.transformSigns;
const {
  formatDate
} = svs.components.lbUtils.helpers;
const {
  selfserviceCart
} = svs.components;
const {
  EventTypeId
} = svs.components.sportinfo.common.constants;
const {
  getProductConfigDataByDraw
} = svs.components.lbUtils.brandMapping.fn;
const {
  actions,
  PARAM_ACTION
} = svs.components.sport.tipsenShared;
const extraOptions = {
  url: {
    params: [[PARAM_ACTION, actions.PAY]]
  }
};
const isSelfService = (_svs$core$config$data = svs.core.config.data) !== null && _svs$core$config$data !== void 0 && (_svs$core$config$data2 = _svs$core$config$data.svsconfig) !== null && _svs$core$config$data2 !== void 0 && _svs$core$config$data2.isSelfService ? svs.core.config.data.svsconfig.isSelfService : false;
const addonProductName = {
  [productIds.STRYKTIPSET]: 'Fullträff Stryktipset',
  [productIds.T8STRYK]: 'Fullträff Topptipset'
};
const getProductName = wagerProp => {
  const productId = resolveProductId(wagerProp.productId);
  return addonProductName[productId];
};
const placeSelfServiceBet = wagerWrapper => new Promise((resolve, reject) => {
  selfserviceCart.getCartInstance().actions.addItem(wagerWrapper, err => {
    if (err) {
      reject(err);
    } else {
      resolve();
    }
  });
});
const handleSelfServiceBet = async (wagers, wagersProps, draws, onPaymentDone) => {
  let i = 0;
  try {
    for (; i < wagers.length; i++) {
      var _activeWagerProps$ext, _activeWagerProps$ext2;
      const activeWager = wagers[i];
      const activeWagerProps = wagersProps[i];
      const activeDraw = draws[i];
      const {
        displayName,
        brandLogo,
        unknownProduct
      } = getProductConfigDataByDraw(activeDraw, resolveProductId(activeWagerProps.productId));
      let addonProductName;
      if (wagers.length > 1 && i) {
        addonProductName = getProductName(wagersProps[0]);
      }
      const productTitle = unknownProduct ? undefined : displayName;
      const productBrand = unknownProduct ? undefined : brandLogo;
      const productFlag = productTitle || activeWagerProps.productId;
      const cost = activeWagerProps.message.price;
      const regCloseTime = new Date((_activeWagerProps$ext = (_activeWagerProps$ext2 = activeWagerProps.extradata) === null || _activeWagerProps$ext2 === void 0 ? void 0 : _activeWagerProps$ext2.regCloseTime) !== null && _activeWagerProps$ext !== void 0 ? _activeWagerProps$ext : null);
      const description = "Spelstopp: ".concat(formatDate.formatDate(regCloseTime, true, true));
      const productItemInfo = {
        wagers: activeWager,
        isLive: false,
        headers: {
          source: 'SvS:LB:ITS'
        },
        productFlag,
        productTitle,
        productBrand,
        cost,
        description,
        addonProductName
      };
      const wagerWrapper = selfserviceCart.generateProductItem(productItemInfo);
      await placeSelfServiceBet(wagerWrapper);
    }
    onPaymentDone(null, {
      wagerCount: i
    });
  } catch (err) {
    onPaymentDone(err, {
      wagerCount: i
    });
  }
};
const logger = log.getLogger('tipsen:placeBetService');
const placeBetService = function (wager, wagerProps, draw) {
  let overrideErrorHandling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  return new Promise((resolve, reject) => {
    const draws = [].concat(draw);
    const wagers = [].concat(wager);
    const wagersProps = [].concat(wagerProps);
    logger.info(JSON.stringify(wager));
    if (isSelfService) {
      if (selfserviceCart !== null && selfserviceCart !== void 0 && selfserviceCart.getCartInstance && selfserviceCart !== null && selfserviceCart !== void 0 && selfserviceCart.generateProductItem) {
        handleSelfServiceBet(wagers, wagersProps, draws, (error, data) => {
          if (error && data.wagerCount.length === 0) {
            reject(error);
          } else {
            resolve({
              wagerCount: data.wagerCount,
              totalWagerCount: wagers.length
            });
          }
        });
      } else {
        reject(new Error('selfservice-cart is not loaded'));
      }
    } else {
      pay(wager, wagerProps, response => {
        resolve(response);
      }, error => {
        reject(error);
      }, null, overrideErrorHandling, extraOptions);
    }
  });
};
const generateXpertCouponService = _ref => {
  let {
    productId,
    drawNumber,
    systemSize,
    systemType,
    numRows,
    baseRow
  } = _ref;
  return new Promise((resolve, reject) => {
    let path = "/wager/1/xpertwagers/".concat(productId, "?&drawNumber=").concat(drawNumber, "&systemType=").concat(systemType, "&numRows=").concat(numRows);
    if (systemSize) {
      path += "&systemSize=".concat(systemSize);
    }
    if (baseRow) {
      path += "&baseRow=".concat(baseRow);
    }
    jupiter.get(path, response => {
      var _response$wager, _response$wager$bets, _response$wager$bets$, _response$wager$bets$2;
      const boardData = response === null || response === void 0 ? void 0 : (_response$wager = response.wager) === null || _response$wager === void 0 ? void 0 : (_response$wager$bets = _response$wager.bets) === null || _response$wager$bets === void 0 ? void 0 : (_response$wager$bets$ = _response$wager$bets[0]) === null || _response$wager$bets$ === void 0 ? void 0 : (_response$wager$bets$2 = _response$wager$bets$.game1X2Boards) === null || _response$wager$bets$2 === void 0 ? void 0 : _response$wager$bets$2.map(board => board === null || board === void 0 ? void 0 : board.boardData);
      if (!boardData) {
        reject(new Error('Failed to parse response'));
      } else {
        resolve(boardData.map(item => convert1X2ToSigns(item)));
      }
    }, error => {
      reject(error);
    });
  });
};
const SportPixFlavour = {
  Random: 'Random',
  Vanilla: 'Vanilla'
};
const generateSportPixService = _ref2 => {
  let {
    productId,
    drawNumber,
    flavour = SportPixFlavour.Vanilla,
    skewPercentage,
    size,
    guaranteedEvents = {
      events: []
    } 
  } = _ref2;
  return new Promise((resolve, reject) => {
    if (!productId) {
      throw new Error('productId is required');
    }
    if (!drawNumber) {
      throw new Error('drawNumber is required');
    }
    if (!size) {
      throw new Error('size is required');
    }

    const path = '/wager/1/pix';
    const params = new URLSearchParams();
    params.append('productId', productId);
    params.append('drawNumber', drawNumber);
    params.append('flavour', flavour);
    params.append('size', size);
    if (skewPercentage) {
      const minSkewPercentage = 0;
      const maxSkewPercentage = 100;
      params.append('skewPercentage', Math.min(Math.max(parseInt(skewPercentage, 10), minSkewPercentage), maxSkewPercentage));
    }
    const eventTypeId = EventTypeId.GOAL_COUNT;
    const signsToIndex = {
      [EventTypeId.EVENT_1X2]: ['1', 'X', '2'],
      [EventTypeId.GOAL_COUNT]: ['0', '1', '2', '3', '4', '5', '6', '7']
    };
    const signsForEventType = signsToIndex[eventTypeId];
    const signsForEventTypeLength = signsForEventType.length;
    jupiter.post({
      path: "".concat(path, "?").concat(params.toString()),
      data: guaranteedEvents
    }, res => {
      const boards = [];
      const board = new Array(res.pix.events.length).fill(null);
      res.pix.events.forEach(event => {
        const eventIndex = event.eventNumber - 1;
        const row = new Array(signsForEventTypeLength).fill(false);
        signsForEventType.forEach((sign, signIndex) => {
          const foundSign = Boolean(event.outcomes.find(el => el.value === sign));
          row[signIndex] = foundSign;
        });
        board[eventIndex] = row;
      });
      boards.push(board);
      resolve(boards);
    }, error => {
      reject(error.responseJSON.error);
    });
  });
};
setGlobal('svs.components.tipsen.engine.services', {
  placeBetService,
  generateXpertCouponService,
  generateSportPixService
});
 })(window);